<template>
  <div
    class="modal lp-speedbump"
    id="lsOffsiteModal"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div v-html="messageHtml"></div>
        </div>
        <div class="modal-footer border-0">
          <a
            :href="modalUrl"
            target="_blank"
            class="btn btn-secondary btn-round offsite-link me-3"
            @click="closeModal"
            >Proceed</a
          >
          <button
            type="button"
            class="btn btn-outline-primary btn-round"
            data-dismiss="modal"
            @click="closeModal"
          >
            Stay here
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop lp-speedbump-backdrop" v-if="backdrop"></div>
</template>
<script>
import { onMounted, reactive, ref, toRef } from 'vue';

import { decodeHtml } from '../helpers/html';

export default {
  name: 'SpeedBump',
  props: {
    backdrop: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      required: true,
    },
    urls: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const messageHtml = ref(decodeHtml(props.message));
    const urlArray = reactive(props.urls.map((url) => url));
    const modalUrl = ref('');
    const modalOptions = {
      backdrop: false,
      focus: true,
      keyboard: true,
    };
    let modalBackdrop = undefined;

    const initModal = () => {
      if (props.backdrop) {
        modalBackdrop = document.querySelector('.lp-speedbump-backdrop');
      }
    };
    const openModal = () => {
      if (lsOffsiteModal) {
        lsOffsiteModal.show();

        if (modalBackdrop) {
          modalBackdrop.classList.add('show');
        }
      }
    };
    const closeModal = () => {
      if (lsOffsiteModal) {
        lsOffsiteModal.hide();

        if (modalBackdrop) {
          modalBackdrop.classList.remove('show');
        }
      }
    };

    const watchLink = (event) => {
      const self = event.target;
      if (self) {
        const url = self.getAttribute('href');
        // eslint-disable-next-line no-script-url
        if (
          url &&
          !url.startsWith('#') &&
          !url.includes('javascript:') &&
          !self.classList.contains('offsite-link') &&
          !url.includes('tel:') &&
          !url.includes('mailto:')
        ) {
          event.preventDefault();

          if (self.host !== window.location.host) {
            const safe = urlArray.some((u) => url.includes(u));

            if (lsOffsiteModal && !safe) {
              modalUrl.value = url;
              openModal();
            } else {
              window.location.href = url;
            }
          } else {
            window.location.href = url;
          }
        }
      }
    };

    onMounted(() => {
      initModal();

      const links = document.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', watchLink);
      });
    });

    return { closeModal, messageHtml, modalUrl };
  },
};
</script>
